export default function navigate(path, removeRouteParams) {
    if(removeRouteParams) {
        window.history.pushState({}, document.title, path);
    }
    
    window.location.pathname = `${path}`;
}